<template>
  <div
    :class="{ disabled: disabled }"
    class="resource_editor"
  >
    <div class="resource card">
      <b-overlay
        :show="loading"
        :variant="'white'"
        :opacity="0.9"
        :blur="'2px'"
        style="z-index: 1040;"
      >
        <component
          :is="resourceComponent"
          v-if="resourceComponent"
          :ref="isMain ? 'resourceComponent' : 'annexComponent'"
          :resource="resource"
          :is-main="isMain"
          v-on="$listeners"
        >
          <template v-slot:publication>
            <PublicationCheckbox
              v-if="!isMain"
              :is-main="isMain"
              :resource="resource"
              @loading="setLoading"
              @statechanged="statechanged"
            />
          </template>
        </component>
        <div
          v-else
          class="card-header"
        >
          <div class="header-top">
            <div class="resource_icon">
              <i class="bi bi-question-circle-fill" />
            </div>
            <div class="resource_name">
              {{ $t('datasetDetail.mainResource.empty') }}
            </div>
          </div>
        </div>
        <div class="card-body">
          <ResourceAccordion
            :id="resource.id"
            :key="`resource-accordion-${resource.id}`"
            :is-main="isMain"
            :form-config="$config.forms.resource.geoserver"
            :resource="resource"
            v-on="$listeners"
          />
        </div>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import DatastoreEditor from '@/components/Resource/editors/DatastoreEditor.vue';
import FileDownloadEditor from '@/components/Resource/editors/FileDownloadEditor.vue';
import FileUploadEditor from '@/components/Resource/editors/FileUploadEditor.vue';
import FTPEditor from '@/components/Resource/editors/FTPEditor.vue';
import GeoserverEditor from '@/components/Resource/editors/GeoserverEditor.vue';
import HrefEditor from '@/components/Resource/editors/HrefEditor.vue';
import datasetAPI from '../../api/modules/dataset.api';
import PublicationCheckbox from '@/components/Resource/PublicationCheckbox.vue';
import ResourceAccordion from '@/components/Resource/ResourceAccordion.vue';
import { ErrorService } from '@/services/error-service.js';
export default {
  name: 'ResourceEditor',

  components: {
    PublicationCheckbox,
    ResourceAccordion
  },

  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    isMain: {
      type: Boolean,
      default: true
    },
    dataset: {
      type: Object,
      default: () => {}
    },
    resource: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      loading: false
    };
  },

  computed: {
    resourceComponent() {
      if (this.resource) {
        switch (this.resource.type) {
        case 'postgres':
        case 'postgis':
          return DatastoreEditor;
        case 'file-upload':
          return FileUploadEditor;
        case 'ftp':
          return FTPEditor;
        case 'href':
          return HrefEditor;
        case 'file-download':
          return FileDownloadEditor;
        case 'geoserver':
          return GeoserverEditor;
        default:
          return null;
        }
      }
      return null;
    }
  },

  methods: {
    setLoading(e) {
      this.loading = e;
    },
    statechanged(){
      this.resource.dirty=true;
      /*
      datasetAPI.updateDatasetResource(this.dataset.id, this.resource,false)
        .then(() => {
          ErrorService.onSuccess(
            true,
            `La mise à jour de la ressource <b>${
              this.resource.display_name ? this.resource.display_name : ''
            }</b> a été lancée avec succès.<br> Vous devez enregistrer le jeux de données pour que la modification soit appliquée`
          );   
        })
        .catch((err) => {
          console.error(err);
        });
        */
    }
  }
};
</script>
